
import { useSelector } from "react-redux";
import Header from "./header/header";

import VenueSidebar from "./componants/sidebar/venueSidebar";
import HotelSidebar from "./componants/sidebar/hotelSidebar";
import EventSidebar from "./componants/sidebar/eventSidebar";
import HolidayPackageSidebar from "./componants/sidebar/holidayPackageSidebar";
import { useState } from "react";

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
   const { user, role } = useSelector((state) => state.auth);
  const vendorType = role || user?.vendor_type;

  const renderSidebar = () => {
    switch (vendorType) {
      case "venue":
        return <VenueSidebar collapsed={collapsed} />;

      case "hotel":
        return <HotelSidebar collapsed={collapsed} />;

      case "event":
        return <EventSidebar collapsed={collapsed} />;

      case "travel_package":
        return <HolidayPackageSidebar collapsed={collapsed} />;

      default:
        return null;
    }
  };

  return (
    <div className="app-wrapper">
      {renderSidebar()}

      <div className={`main-section ${collapsed ? "collapsed" : ""}`}>
        <Header onToggle={() => setCollapsed(!collapsed)} />
        <div className="page-content">{children}</div>
      </div>
    </div>
  );
};

export default Layout;